<template>
  <div class="content">
    <p class="ttile">
      图片广告<span
        >(说明:图片广告仅支持图片展示，可在图片上设置链接到页面地址。)
      </span>
    </p>
    <div class="set-content">
      <div class="set-item">
        <p class="title">选择类型</p>
        <TypeGroup v-model="curComponent.type" :options="typeOptions" />
      </div>

      <div class="set-item add-img">
        <p class="title">添加图片</p>
        <p class="dec">
          建议图片尺寸宽度750，高度不限制。支持.jpg、.gif、png，最多1张，单个图片不超过10M。
        </p>

        <UploadImgList
          v-model="imgList"
          :maxLength="maxLength"
          :templateParams="{ path: '', imgUrl: '' }"
        />
      </div>

      <div class="set-item basic-set">
        <p class="title">样式基础设置</p>
        <SpPickerColor
          v-if="haveBackgroundColorField"
          :isGradient="true"
          v-model="curComponent.backgroundColor"
          defaultColor="rgba(255,255,255,0)"
          label="背景颜色"
        />
        <SpSlider
          v-if="haveRadiusField"
          v-model="curComponent.radius"
          label="圆角值"
        />
        <SpSlider v-model="curComponent.pageMx" label="页面间距" />
        <SpSlider v-model="curComponent.mb" label="页面底部间距" />
      </div>
    </div>
  </div>
</template>

<script>
import typeOptions from "./typeOptions";

import TypeGroup from "./components/TypeGroup";
import SpSlider from "../../../components/SpSlider";
import SpPickerColor from "../../../components/SpPickerColor";
import UploadImgList from "../../../components/UploadImgList";
export default {
  components: {
    SpSlider,
    TypeGroup,
    SpPickerColor,
    UploadImgList
  },
  inject: ["control"],
  data() {
    return {
      typeOptions: Object.freeze(typeOptions)
    };
  },
  computed: {
    imgList: {
      get() {
        const imgs = this.control.curComponent.imgs;
        // 没有就创建一项
        if (!this.curComponent.imgs[0]) {
          const initParams = {
            path: "",
            imgUrl: ""
          };
          this.$set(imgs, 0, initParams);
        }
        return imgs;
      },
      set(val) {
        this.$set(this.control.curComponent, "imgs", val);
      }
    },
    maxLength() {
      return {
        oneLineOne: 1,
        carousel: 10,
        slider: 10
      }[this.curComponent.type];
    },
    curComponent() {
      return this.control.curComponent;
    },
    // v1.2.1新增 - start
    haveBackgroundColorField() {
      const flag = "backgroundColor" in this.curComponent;
      if (!flag) {
        this.$set(
          this.control.curComponent,
          "backgroundColor",
          "rgba(255,255,255,0)"
        );
      }
      return "backgroundColor" in this.curComponent;
    },
    haveRadiusField() {
      const flag = "radius" in this.curComponent;
      if (!flag) {
        this.$set(this.control.curComponent, "radius", 0);
      }
      return "radius" in this.curComponent;
    }
    // end
  }
};
</script>

<style lang="less" scoped>
.content {
  .ttile {
    padding: 22px 24px 20px 24px;
    font-size: 16px;
    border-bottom: 1px solid #eee;
    font-weight: 500;
    span {
      font-size: 10px;
      color: #999999;
      padding-left: 10px;
    }
  }
  > .set-content {
    padding-top: 15px;
    padding: 20px 24px;
    > .set-item {
      > .title {
        font-size: 14px;
        font-weight: 500;
        margin-bottom: 12px;
      }
      > .dec {
        font-size: 12px;
        color: #999999;
        font-weight: 400;
        margin-bottom: 20px;
      }
      > .select-view {
        margin-top: 12px;
        > span {
          font-size: 12px;
          font-weight: 400;
        }
        > span:first-child {
          color: #999999;
        }
        > span:last-child {
          color: #333333;
          padding-left: 10px;
        }
      }
    }
    > .add-img {
      margin-top: 30px;
    }

    > .basic-set {
      margin-top: 30px;
      /deep/ .slider-content,
      .picker-color {
        margin-bottom: 17px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/custom-component/baseComponents/PictureAdvertising/Attr.vue